import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-shape",
  "use": "icon-shape-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-shape\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M14.92,8A7,7,0,1,0,8,16v6H23V8ZM3,9a5,5,0,0,1,9.9-1H8v6A5,5,0,0,1,3,9Zm9.9,1A5,5,0,0,1,10,13.58V10ZM21,20H10V15.71A7,7,0,0,0,14.92,10H21Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol